/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable no-console */
import React, { useState, MouseEvent } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import ConfirmIcon from "@mui/icons-material/QuestionMarkOutlined";

import { DialogState, setConfirmation, setConfirmationSetter } from "../../logic/hook/useDialogStateHelper";

import { StyledDialog } from "./Dialog";

export const ConfirmationDialog = () => {
    const [confirmationState, setConfirmationState] = useState<DialogState>({ open: false });
    setConfirmationSetter(setConfirmationState);
    setConfirmation(confirmationState);
    const resolve = () => {
        const { resolve: _resolve = () => {} } = confirmationState;
        _resolve(false);
    };
    const reject = () => {
        const { reject: _reject = () => {} } = confirmationState;
        _reject();
    };

    const close = () => setConfirmationState({ open: false });

    const onClickOK = () => {
        resolve();
        close();
    };

    const onClickCancel = () => {
        reject();
        close();
    };

    const onClose = (event: MouseEvent<HTMLInputElement>, reason: "backdropClick") => {
        // バックドロップクリック時に閉じるのを無効化
        if (reason === "backdropClick") {
            return;
        }
        close();
    };

    return (
        <>
            {confirmationState.open && confirmationState.message && (
                <StyledDialog open={confirmationState.open} onClose={onClose} fullWidth>
                    <DialogTitle component="div">
                        <Grid container direction="row" justifyContent="flex-start" alignItems="center" sx={{ width: "100%" }}>
                            <ConfirmIcon />
                            確認
                        </Grid>
                    </DialogTitle>
                    <DialogContent dividers sx={{ maxHeight: "70vh" }}>
                        <DialogContentText
                            dangerouslySetInnerHTML={{
                                __html: confirmationState.message,
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClickOK} size="small">
                            OK
                        </Button>
                        <Button onClick={onClickCancel} size="small">
                            キャンセル
                        </Button>
                    </DialogActions>
                </StyledDialog>
            )}
        </>
    );
};
